

































































































import { Component, Prop, Ref, Vue } from "vue-property-decorator";
import { Auth } from "aws-amplify";
import * as rules from '@/rules';
import { Urls } from "@/Urls";

@Component({
    components: {}
})
export default class ChangePassword extends Vue {

    @Prop({required: true})
    username!: string;

    @Prop({required: true})
    confirmationCode!: string;

    @Ref()
    private formRef: HTMLFormElement;

    private form: any = {};

    private showPassword = false;

    private error = null;
    private sending = false;

    private rules = {
        required: rules.REQUIRED,
        passwordRequirements: rules.PASSWORD_STRENGTH,
        passwordMatch: (v: string) => !!v && v == this.form.password || 'Passwords do not match.'
    }

    private changePassword() {
        if (!this.formRef.validate()) {
            return;
        }
        this.sending = true;
        Auth.forgotPasswordSubmit(this.username, this.confirmationCode, this.form.password)
            .then(result => {
                this.sending = false;
                this.$router.push(Urls.LOGIN);
            })
            .catch(err => {
                this.sending = false;
                this.error = err;
                console.log(err)
            })

    }

}
